import { ISubcommitteesFormValues } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';

type MasterDataType = {
  id: number;
  nameTh: string;
  nameEn: string;
};

const findMasterData = (
  id: number | string | undefined,
  masterData: MasterDataType[]
) => masterData.find((data) => data.id === id);

export const mappingSubcommitteesDataTable = (
  subcommitteeRoles: ISubcommitteesFormValues[],
  subcommitteeMasterData: MasterDataType[]
) => {
  return subcommitteeRoles.map((role, index) => {
    const subcommitteeData = role.subcommitteeRoles?.map((subcommittee) => {
      return findMasterData(
        subcommittee.infoCategoryMasterDataId,
        subcommitteeMasterData
      );
    });
    return {
      ...role,
      id: role.id ?? `NEW-${index + 1}`,
      subcommitteeRoles: {
        nameTh: subcommitteeData?.map((data) => data?.nameTh),
        nameEn: subcommitteeData?.map((data) => data?.nameEn),
      },
      otherSubcommitteeRoles: {
        nameTh: role.otherSubcommitteeRoles?.map((data) => data?.nameTh),
        nameEn: role.otherSubcommitteeRoles?.map((data) => data?.nameEn),
      },
    };
  });
};
